export interface GenericErrorProps {
  show: boolean
}

const GenericError = ({ show }: GenericErrorProps) => {
  if (!show) {
    return null
  }

  return (
    <div className='form-group'>
      <div className='validation-error error-message'>
        <span className='error-message-text'>There was an error, please try again later</span>
      </div>
    </div>
  )
}

export default GenericError
